import { Outlet } from 'react-router-dom'
import Header from './Header'
import BottomNav from './BottomNav'
import { useAuth } from '@/hooks/useAuth'

/**
 * The frame for every signed-in screen: a header, one centred column, and on phones a tab
 * bar at the bottom. No side panels.
 */
const Layout = () => {
  const { athlete, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-t-2 border-[#65A30D]" />
      </div>
    )
  }

  if (!athlete) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground">Please sign in</h1>
          <p className="mt-2 text-muted-foreground">Your session has ended.</p>
          <button
            className="mt-6 rounded-xl bg-[#C0FD72] px-5 py-2.5 font-semibold text-[#0F172A]"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main
        className="mx-auto w-full min-w-0 max-w-[1100px] flex-1 px-4 py-4 pb-24 md:px-6 md:py-6 md:pb-8"
      >
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}

export default Layout
